import { motion } from "framer-motion";
import { Bot, ArrowRight } from "lucide-react";
import { GIULIA_POLES } from "@/giulia/giuliaData";
import { GIULIA_SITE_URL } from "@/lib/giuliaConfig";

const ACCENT = "#6366F1";
const GLOW = "rgba(99,102,241,0.30)";

const reveal = {
  initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.2 }, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
};

export const GiuliaTeaser = () => (
  <section id="giuliateck" className="relative py-20 sm:py-28 overflow-hidden" data-testid="giulia-teaser">
    <div aria-hidden="true" className="absolute inset-0 pointer-events-none" style={{ background: `radial-gradient(900px circle at 50% 0%, ${GLOW}, transparent 70%)` }} />
    <div className="max-w-5xl mx-auto px-5 sm:px-8 relative text-center">
      <motion.p {...reveal} className="font-mono-ui text-[11px] uppercase tracking-[0.3em] mb-4" style={{ color: ACCENT }}>GiulIATeck — la marque IA de Pépé</motion.p>
      <motion.h2 {...reveal} className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-none">Voici <span className="text-outline">Giulia</span>, l'IA qui bosse pour ton entreprise</motion.h2>
      <motion.blockquote {...reveal} className="mt-6 max-w-2xl mx-auto text-slate-300 text-base sm:text-lg leading-relaxed" data-testid="giulia-teaser-accroche">
        « Giulia surveille ton marché, crée tes contenus et tes pubs, répond à tes prospects 24/7 et remplit ton agenda. <strong className="text-white">Tu valides, elle exécute.</strong> »
      </motion.blockquote>

      <motion.ul {...reveal} className="mt-10 grid grid-cols-3 sm:grid-cols-6 gap-3 sm:gap-4" data-testid="giulia-teaser-poles">
        {GIULIA_POLES.map((pole) => {
          const Icon = pole.icon;
          return (
            <li key={pole.n} className="glass border border-line rounded-xl p-3 sm:p-4 flex flex-col items-center gap-2" data-testid={`giulia-teaser-pole-${pole.n}`}>
              <span className="grid place-items-center w-10 h-10 rounded-lg" style={{ background: GLOW, color: "#c7d2fe" }}><Icon size={18} /></span>
              <span className="text-[11px] sm:text-xs text-slate-300 leading-tight text-center">{pole.title}</span>
            </li>
          );
        })}
      </motion.ul>

      <motion.a {...reveal} href={GIULIA_SITE_URL} data-testid="giulia-teaser-cta"
        className="mt-10 inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-bold uppercase tracking-wide text-sm hover:scale-[1.04] active:scale-95 transition-transform"
        style={{ background: ACCENT, boxShadow: `0 0 30px ${GLOW}` }}>
        <Bot size={18} />Découvrir Giulia<ArrowRight size={16} />
      </motion.a>
      <motion.p {...reveal} className="mt-4 font-mono-ui text-[11px] uppercase tracking-widest text-slate-500">Veille · Création · Diffusion · Capture · Conversion · Pilotage</motion.p>
    </div>
  </section>
);
